export default __webpack_public_path__ + "assets/icons/plus.c4de0f10.svg";